var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2",attrs:{"id":"app"}},[_c('Head',{attrs:{"msg":"Welcome to Your Vue.js App"}}),_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }